function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 77,
    viewBox: "0 0 82 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M80.5332 1.4668V75.5332H1.4668V39.7979L1.55664 39.6641L11.3066 25.0635L11.75 24.3994L12.1934 25.0635L21.5 39L30.8066 25.0635L31.25 24.3994L31.6934 25.0635L41 39L50.3066 25.0635L50.75 24.3994L51.1934 25.0635L59.9668 38.2012V1.4668H80.5332Z",
    fill: "black",
    stroke: "black",
    style: {
      fill: "black",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.06667
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/company-icon.10796abc9506a63afe25220115ddd6ce.svg";
export { ForwardRef as ReactComponent };